import PropTypes from "prop-types";
import { viewPhoneFromFlat } from "@shared/models/Communications/viewPhone";
import smsStatusIconForStatus from "@shared/models/Communications/viewPhoneIcons/SmsStatusIcon";
import BaseEvent from "../BaseEvent";

const SMS_DICTIONARY = {
  valid: "Can be Texted",
  untextable: "Cannot be Texted",
  "opted-out": "Opted Out",
};

const statusMap = {
  "opted-out": "unsubscribed",
  untextable: "invalid",
};

const borderClasses = {
  unsubscribed: "!tw-border-brivity-coral-110",
  invalid: "!tw-border-semantic-yellow-100",
};

const statusClassMap = {
  unsubscribed: "!tw-text-brivity-coral-110",
  invalid: "!tw-text-semantic-yellow-100",
};

const TimelineSmsSoftStatusChangeEvent = ({ event }) => {
  const timelineFields = event.timeline_fields;
  const { lead_phone_number: leadPhoneNumber, author_name: authorName, change, category } = timelineFields;
  const phone = viewPhoneFromFlat({ value: leadPhoneNumber });
  const changeSet = change.sms_status;
  const finalState = SMS_DICTIONARY[changeSet[1]];
  const textStatus = statusMap[changeSet[1]] || "valid";

  const smsIcon = smsStatusIconForStatus(textStatus);

  return (
    <BaseEvent
      icon={smsIcon.icon({ size: "l" })}
      title={
        <div>
          <span className="tw-font-bold">{authorName}</span> updated a text status
        </div>
      }
      interactedAt={event.interacted_at_absolute}
      iconContainerClass={`tw-w-40px tw-h-40px ${borderClasses[textStatus] || ""}`}
    >
      <p>
        Status of {phone.formattedNumber}{" "}
        <span className="tw-capitalize">{category ? `(${category})` : ""}</span> was updated to{" "}
        <span className={`tw-font-bold ${statusClassMap[textStatus] || ""}`}>{finalState}</span>
      </p>
    </BaseEvent>
  );
};
TimelineSmsSoftStatusChangeEvent.propTypes = {
  event: PropTypes.shape({
    timeline_fields: PropTypes.shape({
      lead_phone_number: PropTypes.string,
      author_name: PropTypes.string,
      category: PropTypes.string,
      change: PropTypes.shape({
        sms_status: PropTypes.arrayOf(PropTypes.string),
      }),
    }),
    interacted_at_absolute: PropTypes.string,
  }),
};

TimelineSmsSoftStatusChangeEvent.defaultProps = {
  event: {
    timeline_fields: { lead_phone_number: "", author_name: "", change: {}, category: "" },
    interacted_at_absolute: "",
  },
};

export default TimelineSmsSoftStatusChangeEvent;
